(function (root, factory) {
  var api = factory();
  typeof module == "object" && module.exports && (module.exports = api),
    root && ((root.IM8ClickAttribution = api), api.install(root));
})(typeof window != "undefined" ? window : null, function () {
  "use strict";
  var PARAMETER_KEYS = [
      "gclid",
      "gbraid",
      "wbraid",
      "fbclid",
      "ttclid",
      "msclkid",
      "nbt",
      "tblci",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
    ],
    CLICK_ID_KEYS = [
      "gclid",
      "gbraid",
      "wbraid",
      "fbclid",
      "ttclid",
      "msclkid",
      "nbt",
      "tblci",
    ],
    UTM_KEYS = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
    ],
    FRONTROW_ATTRIBUTE_KEYS = [
      "_frontrow_assisted",
      "_frontrow_engaged_ts",
      "_frontrow_visitor_token",
    ],
    FRONTROW_STORAGE_KEY = "im8_frontrow_assisted",
    FRONTROW_TOKEN_STORAGE_KEY = "frontrow_visitor_token",
    FRONTROW_ALLOWED_HOST = "thefrontrowhealth.com",
    FRONTROW_EVENT_PATTERN = /OPEN|MAXIMIZE|PROVIDER_MODAL|ASK|GPT/i,
    CART_ATTRIBUTE_KEYS = CLICK_ID_KEYS.map(function (key) {
      return "_" + key;
    }).concat(
      UTM_KEYS.reduce(function (keys, key) {
        return keys.push("_first_" + key, "_last_" + key), keys;
      }, []),
      ["_first_touch_ts", "_last_touch_ts"],
      FRONTROW_ATTRIBUTE_KEYS,
    );
  function readLandingTouch(search, timestamp) {
    var params = new URLSearchParams(search || ""),
      touch = { ts: timestamp },
      captured = !1;
    return (
      PARAMETER_KEYS.forEach(function (key) {
        var value = String(params.get(key) || "")
          .trim()
          .slice(0, 512);
        value && ((touch[key] = value), (captured = !0));
      }),
      captured ? touch : null
    );
  }
  function hasUtm(touch) {
    return touch
      ? UTM_KEYS.some(function (key) {
          return !!touch[key];
        })
      : !1;
  }
  function mergeTouch(state, touch) {
    var ids = {},
      firstUtm =
        state && (state.firstUtm || (hasUtm(state.first) ? state.first : null)),
      lastUtm =
        state &&
        (state.lastUtm || (hasUtm(state.last) ? state.last : firstUtm));
    return (
      state &&
        state.ids &&
        Object.keys(state.ids).forEach(function (key) {
          ids[key] = state.ids[key];
        }),
      CLICK_ID_KEYS.forEach(function (key) {
        touch[key] && (ids[key] = touch[key]);
      }),
      hasUtm(touch) && (firstUtm || (firstUtm = touch), (lastUtm = touch)),
      {
        v: 1,
        first: state && state.first ? state.first : touch,
        last: touch,
        firstUtm: firstUtm || null,
        lastUtm: lastUtm || null,
        ids: ids,
      }
    );
  }
  function assignIfPresent(target, key, value) {
    value && (target[key] = value);
  }
  function buildCartAttributes(state) {
    if (!state || !state.first) return {};
    var first = state.first,
      last = state.last || first,
      firstUtm = state.firstUtm || (hasUtm(first) ? first : null),
      lastUtm = state.lastUtm || (hasUtm(last) ? last : firstUtm),
      attributes = buildClearedCartAttributes();
    return (
      CLICK_ID_KEYS.forEach(function (key) {
        assignIfPresent(
          attributes,
          "_" + key,
          (state.ids && state.ids[key]) || last[key] || first[key],
        );
      }),
      UTM_KEYS.forEach(function (key) {
        assignIfPresent(attributes, "_first_" + key, firstUtm && firstUtm[key]),
          assignIfPresent(attributes, "_last_" + key, lastUtm && lastUtm[key]);
      }),
      assignIfPresent(attributes, "_first_touch_ts", first.ts),
      assignIfPresent(attributes, "_last_touch_ts", last.ts),
      attributes
    );
  }
  function buildClearedCartAttributes() {
    var attributes = {};
    return (
      CART_ATTRIBUTE_KEYS.forEach(function (key) {
        attributes[key] = "";
      }),
      attributes
    );
  }
  function isMarketingAllowed(customerPrivacy) {
    if (
      !customerPrivacy ||
      typeof customerPrivacy.marketingAllowed != "function"
    )
      return !1;
    try {
      return customerPrivacy.marketingAllowed() === !0;
    } catch (error) {
      return !1;
    }
  }
  function buildConsentAttributes(customerPrivacy, observedAt) {
    var attributes = {};
    [
      "id",
      "marketing",
      "analytics",
      "preferences",
      "sale_of_data",
      "region",
      "marketing_allowed",
      "sale_of_data_allowed",
      "source",
      "observed_at",
    ].forEach(function (key) {
      attributes["_shopify_consent_" + key] = "";
    });
    var choices;
    try {
      choices = customerPrivacy && customerPrivacy.currentVisitorConsent();
    } catch (error) {
      return attributes;
    }
    if (!choices || typeof choices != "object" || Array.isArray(choices))
      return attributes;
    function read(method) {
      try {
        return typeof customerPrivacy[method] == "function"
          ? customerPrivacy[method]()
          : null;
      } catch (error) {
        return null;
      }
    }
    ["marketing", "analytics", "preferences", "sale_of_data"].forEach(
      function (key) {
        var value = choices[key];
        attributes["_shopify_consent_" + key] =
          value === "yes" || value === "no" ? value : "unknown";
      },
    );
    var id = read("consentId"),
      region = read("getRegion");
    return (
      (attributes._shopify_consent_id =
        typeof id == "string" &&
        /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(
          id,
        )
          ? id
          : ""),
      (attributes._shopify_consent_region =
        typeof region == "string" && /^[A-Z]{2}[A-Z0-9]{0,3}$/.test(region)
          ? region
          : ""),
      [
        ["marketing_allowed", "marketingAllowed"],
        ["sale_of_data_allowed", "saleOfDataAllowed"],
      ].forEach(function (pair) {
        var value = read(pair[1]);
        attributes["_shopify_consent_" + pair[0]] =
          typeof value == "boolean" ? String(value) : "unknown";
      }),
      (attributes._shopify_consent_source = "customer-privacy-api-v1"),
      (attributes._shopify_consent_observed_at =
        typeof observedAt == "string" && Number.isFinite(Date.parse(observedAt))
          ? new Date(observedAt).toISOString()
          : ""),
      attributes
    );
  }
  function isFrontrowOrigin(origin) {
    if (typeof origin != "string") return !1;
    var match = /^https:\/\/([^/:?#]+)(?::\d+)?$/i.exec(origin);
    if (!match) return !1;
    var host = match[1].toLowerCase();
    return (
      host === FRONTROW_ALLOWED_HOST ||
      host.slice(-(FRONTROW_ALLOWED_HOST.length + 1)) ===
        "." + FRONTROW_ALLOWED_HOST
    );
  }
  function buildFrontrowAttributes(
    markerValue,
    tokenValue,
    nowTimestamp,
    retentionMs,
  ) {
    var attributes = {},
      marker = null;
    if (markerValue)
      try {
        marker = JSON.parse(markerValue);
      } catch (error) {
        marker = null;
      }
    var engagedAt = marker && marker.t;
    return (
      typeof engagedAt == "number" &&
        Number.isFinite(engagedAt) &&
        Number.isFinite(nowTimestamp) &&
        nowTimestamp - engagedAt <= retentionMs &&
        ((attributes._frontrow_assisted = "true"),
        (attributes._frontrow_engaged_ts = new Date(engagedAt).toISOString())),
      typeof tokenValue == "string" &&
        tokenValue &&
        (attributes._frontrow_visitor_token = tokenValue.slice(0, 512)),
      attributes
    );
  }
  function createTracker(options) {
    var trackerRoot = options.root,
      storage = options.storage,
      request = options.fetch,
      now = options.now,
      landingSearch =
        typeof options.landingSearch == "string"
          ? options.landingSearch
          : (trackerRoot.location && trackerRoot.location.search) || "",
      schedule =
        options.setTimeout ||
        (trackerRoot.setTimeout && trackerRoot.setTimeout.bind(trackerRoot)) ||
        setTimeout,
      landingCaptured = !1,
      fallbackState = null,
      hasAttribution = !1,
      needsCartClear = !1,
      retentionMs = (options.retentionDays || 90) * 24 * 60 * 60 * 1e3,
      clearPendingKey = "im8_attr_clear_pending",
      lastPayload = null,
      pendingWrites = Object.create(null),
      writeTail = null,
      activeWriteCount = 0,
      consentFingerprint = null,
      consentObservation = null;
    function consentAttributes() {
      var privacy = trackerRoot.Shopify && trackerRoot.Shopify.customerPrivacy,
        snapshot = buildConsentAttributes(privacy, null),
        fingerprint = JSON.stringify(snapshot);
      return (
        fingerprint !== consentFingerprint &&
          ((consentFingerprint = fingerprint),
          (snapshot._shopify_consent_observed_at =
            snapshot._shopify_consent_source ? now() : ""),
          (consentObservation = snapshot)),
        consentObservation
      );
    }
    function readStorageItem(key) {
      try {
        return { available: !0, value: storage.getItem(key) };
      } catch (error) {
        return { available: !1, value: null };
      }
    }
    function removeStorageItem(key) {
      try {
        storage.removeItem(key);
      } catch (error) {
        return !1;
      }
      return !0;
    }
    function removeState() {
      fallbackState = null;
      return removeStorageItem("im8_attr");
    }
    function markClearPending() {
      try {
        storage.setItem(clearPendingKey, "1");
      } catch (error) {
        return !1;
      }
      return !0;
    }
    function clearPending() {
      return removeStorageItem(clearPendingKey);
    }
    function isClearPending() {
      return readStorageItem(clearPendingKey).value === "1";
    }
    function readState() {
      if (fallbackState) return fallbackState;
      var stored = readStorageItem("im8_attr");
      if (!stored.available || !stored.value) return null;
      try {
        return JSON.parse(stored.value) || null;
      } catch (error) {
        return removeState(), null;
      }
    }
    function writeState(state) {
      hasAttribution = !0;
      // Keep this page's capture until storage confirms it, including no-op storage.
      fallbackState = state;
      try {
        var serialized = JSON.stringify(state);
        storage.setItem("im8_attr", serialized);
        if (storage.getItem("im8_attr") === serialized) fallbackState = null;
      } catch (error) {
        return !1;
      }
      return !0;
    }
    function isExpired(state) {
      if (!state) return !1;
      var firstTimestamp = state.first && Date.parse(state.first.ts),
        currentTimestamp = Date.parse(now());
      return (
        !Number.isFinite(firstTimestamp) ||
        !Number.isFinite(currentTimestamp) ||
        currentTimestamp - firstTimestamp > retentionMs
      );
    }
    function cartUpdateUrl() {
      if (trackerRoot.routes && trackerRoot.routes.cart_update_url)
        return trackerRoot.routes.cart_update_url;
      var shopifyRoot =
        trackerRoot.Shopify &&
        trackerRoot.Shopify.routes &&
        trackerRoot.Shopify.routes.root;
      return (shopifyRoot || "/") + "cart/update.js";
    }
    function persist(attributes, status) {
      attributes = Object.assign({}, attributes, consentAttributes());
      var payload = JSON.stringify({ attributes: attributes }),
        resultWhenUnchanged =
          status === "cleared"
            ? { status: "cleared" }
            : { status: "unchanged", attributes: attributes };
      if (payload === lastPayload) return Promise.resolve(resultWhenUnchanged);
      if (pendingWrites[payload]) return pendingWrites[payload];
      function performWrite() {
        var shopify = trackerRoot && trackerRoot.Shopify,
          customerPrivacy = shopify && shopify.customerPrivacy;
        if (status !== "cleared" && !isMarketingAllowed(customerPrivacy))
          return Promise.resolve({ status: "superseded" });
        var writeAttributes = Object.assign(
            {},
            attributes,
            consentAttributes(),
          ),
          writePayload = JSON.stringify({ attributes: writeAttributes });
        if (writePayload === lastPayload)
          return Promise.resolve(resultWhenUnchanged);
        (activeWriteCount += 1),
          (trackerRoot.__im8AttributionCartUpdateInFlight = !0);
        var responsePromise;
        try {
          responsePromise = request(cartUpdateUrl(), {
            method: "POST",
            credentials: "same-origin",
            keepalive: !0,
            headers: {
              "Content-Type": "application/json",
              "X-IM8-Attribution-Write": "1",
            },
            body: writePayload,
          });
        } catch (error) {
          responsePromise = Promise.reject(error);
        }
        return Promise.resolve(responsePromise)
          .then(function (response) {
            if (!response.ok)
              throw new Error(
                "Cart attribution update failed: " + response.status,
              );
            return (
              (lastPayload = writePayload),
              status === "cleared"
                ? { status: "cleared" }
                : { status: "persisted", attributes: writeAttributes }
            );
          })
          .finally(function () {
            schedule(function () {
              (activeWriteCount = Math.max(0, activeWriteCount - 1)),
                (trackerRoot.__im8AttributionCartUpdateInFlight =
                  activeWriteCount > 0),
                activeWriteCount === 0 &&
                  typeof trackerRoot.dispatchEvent == "function" &&
                  typeof trackerRoot.CustomEvent == "function" &&
                  trackerRoot.dispatchEvent(
                    new trackerRoot.CustomEvent(
                      "im8:attribution-write-settled",
                    ),
                  );
            }, 750);
          });
      }
      var previousWrite = writeTail,
        operation = previousWrite
          ? previousWrite.catch(function () {}).then(performWrite)
          : performWrite();
      (writeTail = operation), (pendingWrites[payload] = operation);
      function releaseOperation() {
        pendingWrites[payload] === operation && delete pendingWrites[payload],
          writeTail === operation && (writeTail = null);
      }
      return operation.then(releaseOperation, releaseOperation), operation;
    }
    return {
      process: function () {
        var shopify = trackerRoot && trackerRoot.Shopify,
          customerPrivacy = shopify && shopify.customerPrivacy;
        if (!isMarketingAllowed(customerPrivacy))
          return (
            markClearPending(),
            removeState(),
            removeStorageItem(FRONTROW_STORAGE_KEY),
            persist(buildClearedCartAttributes(), "cleared")
              .then(function (result) {
                return (hasAttribution = !1), clearPending(), result;
              })
              .catch(function () {
                return { status: "error" };
              })
          );
        var retainedExpiredState = !1,
          deferredState = null,
          state = readState();
        if (
          ((hasAttribution = !!state),
          (needsCartClear = needsCartClear || isClearPending()),
          isExpired(state) &&
            ((fallbackState = null),
            (retainedExpiredState = !markClearPending()),
            retainedExpiredState || removeState(),
            (state = null),
            (hasAttribution = !1),
            (needsCartClear = !0)),
          !landingCaptured)
        ) {
          var touch = readLandingTouch(landingSearch, now());
          (landingCaptured = !0),
            touch &&
              ((state = mergeTouch(state, touch)),
              retainedExpiredState
                ? (fallbackState = deferredState = state)
                : writeState(state));
        }
        var activeAttributes = buildCartAttributes(state),
          frontrowMarker = readStorageItem(FRONTROW_STORAGE_KEY).value,
          frontrowToken = readStorageItem(FRONTROW_TOKEN_STORAGE_KEY).value,
          frontrowAttributes = buildFrontrowAttributes(
            frontrowMarker,
            frontrowToken,
            Date.parse(now()),
            retentionMs,
          );
        frontrowMarker &&
          !frontrowAttributes._frontrow_assisted &&
          removeStorageItem(FRONTROW_STORAGE_KEY),
          Object.keys(frontrowAttributes).length &&
            (Object.keys(activeAttributes).length ||
              (activeAttributes = buildClearedCartAttributes()),
            Object.keys(frontrowAttributes).forEach(function (key) {
              activeAttributes[key] = frontrowAttributes[key];
            }));
        var attributes = activeAttributes;
        return (
          needsCartClear &&
            ((attributes = buildClearedCartAttributes()),
            Object.keys(activeAttributes).forEach(function (key) {
              attributes[key] = activeAttributes[key];
            })),
          persist(
            attributes,
            needsCartClear && !Object.keys(activeAttributes).length
              ? "cleared"
              : null,
          ).then(function (result) {
            return (
              retainedExpiredState &&
                result.status !== "superseded" &&
                (removeState(), deferredState && writeState(deferredState)),
              needsCartClear &&
                result.status !== "superseded" &&
                ((needsCartClear = !1), clearPending()),
              result
            );
          })
        );
      },
    };
  }
  function install(trackerRoot, options) {
    if (!trackerRoot) return null;
    if (trackerRoot.__im8AttributionController)
      return trackerRoot.__im8AttributionController;
    options = options || {};
    var tracker = null,
      attempts = 0,
      initialSearch =
        (trackerRoot.location && trackerRoot.location.search) || "",
      schedule = trackerRoot.setTimeout
        ? trackerRoot.setTimeout.bind(trackerRoot)
        : setTimeout,
      frontrowEngagedSignalled = !1,
      frontrowAskSignalled = !1;
    function signalFrontrowEngagement(name, engagedAt) {
      var asked = /ASK/i.test(name);
      if (!(frontrowEngagedSignalled && (!asked || frontrowAskSignalled))) {
        (frontrowEngagedSignalled = !0), asked && (frontrowAskSignalled = !0);
        var dataLayer = (trackerRoot.dataLayer = trackerRoot.dataLayer || []);
        dataLayer.push({
          event: "clinicianai_engaged",
          frontrow_asked: asked,
          frontrow_event_name: String(name).slice(0, 128),
          frontrow_engaged_ts: new Date(engagedAt).toISOString(),
        });
      }
    }
    function storage() {
      if (options.storage) return options.storage;
      try {
        return trackerRoot.localStorage;
      } catch (error) {
        return {
          getItem: function () {
            return null;
          },
          setItem: function () {},
          removeItem: function () {},
        };
      }
    }
    function process() {
      var customerPrivacy =
        trackerRoot.Shopify && trackerRoot.Shopify.customerPrivacy;
      return customerPrivacy
        ? (tracker ||
            (tracker = createTracker({
              root: trackerRoot,
              landingSearch: initialSearch,
              storage: storage(),
              fetch: options.fetch || trackerRoot.fetch.bind(trackerRoot),
              now:
                options.now ||
                function () {
                  return new Date().toISOString();
                },
              setTimeout: options.setTimeout,
            })),
          tracker.process().catch(function () {
            return { status: "error" };
          }))
        : ((attempts += 1),
          attempts <= 100 && schedule(process, 100),
          Promise.resolve({ status: "waiting" }));
    }
    function beforeNavigation(timeoutMs) {
      return new Promise(function (resolve) {
        var settled = !1;
        function finish() {
          settled || ((settled = !0), resolve());
        }
        function check() {
          if (!settled) {
            var customerPrivacy =
              trackerRoot.Shopify && trackerRoot.Shopify.customerPrivacy;
            if (!customerPrivacy) {
              schedule(check, 50);
              return;
            }
            Promise.resolve(process()).then(finish, finish);
          }
        }
        schedule(finish, timeoutMs || 500), check();
      });
    }
    function resumeCartCheckout(form) {
      var doc = trackerRoot.document,
        live = form && form.isConnected ? form : null;
      if (!live && form && form.id && doc && typeof doc.getElementById == "function")
        live = doc.getElementById(form.id);
      if (!live || !live.isConnected) {
        var root =
          (trackerRoot.Shopify &&
            trackerRoot.Shopify.routes &&
            trackerRoot.Shopify.routes.root) ||
          "/";
        trackerRoot.location.assign(String(root).replace(/\/?$/, "/") + "checkout");
        return;
      }
      var input = doc.createElement("input");
      (input.type = "hidden"),
        (input.name = "checkout"),
        (input.value = "Checkout"),
        live.appendChild(input),
        live.submit();
    }
    function handleCheckoutSubmit(event) {
      var submitter = event && event.submitter,
        form = event && event.target;
      if (!submitter || submitter.name !== "checkout" || !form) return;
      return (
        event.preventDefault(),
        beforeNavigation(500).then(function () {
          resumeCartCheckout(form);
        })
      );
    }
    var rebuyCheckoutBypass = null;
    function handleRebuyCheckoutClick(event) {
      var target = event && event.target;
      if (!(!target || typeof target.closest != "function")) {
        var checkout = target.closest(
          '[data-rebuy-component="checkout-area"] a, [data-rebuy-component="checkout-area"] button',
        );
        if (!(!checkout || checkout.getAttribute("aria-disabled") === "true")) {
          if (rebuyCheckoutBypass === checkout) {
            rebuyCheckoutBypass = null;
            return;
          }
          return (
            event.preventDefault(),
            typeof event.stopImmediatePropagation == "function" &&
              event.stopImmediatePropagation(),
            beforeNavigation(500).then(function () {
              (rebuyCheckoutBypass = checkout), checkout.click();
            })
          );
        }
      }
    }
    function navigate(destination, timeoutMs) {
      return beforeNavigation(timeoutMs).then(function () {
        trackerRoot.location.href = destination;
      });
    }
    function handleFrontrowMessage(event) {
      if (!(!event || !isFrontrowOrigin(event.origin))) {
        var data = event.data,
          name =
            typeof data == "string"
              ? data
              : data && typeof data.name == "string"
                ? data.name
                : "";
        if (!(!name || !FRONTROW_EVENT_PATTERN.test(name))) {
          var customerPrivacy =
            trackerRoot.Shopify && trackerRoot.Shopify.customerPrivacy;
          if (isMarketingAllowed(customerPrivacy)) {
            var engagedAt = Date.parse(
              options.now ? options.now() : new Date().toISOString(),
            );
            if (Number.isFinite(engagedAt)) {
              try {
                storage().setItem(
                  FRONTROW_STORAGE_KEY,
                  JSON.stringify({ t: engagedAt }),
                );
              } catch (error) {
                return;
              }
              return signalFrontrowEngagement(name, engagedAt), process();
            }
          }
        }
      }
    }
    var controller = {
      process: process,
      beforeNavigation: beforeNavigation,
      navigate: navigate,
    };
    trackerRoot.__im8AttributionController = controller;
    var eventTarget = trackerRoot.document || trackerRoot;
    return (
      eventTarget &&
        typeof eventTarget.addEventListener == "function" &&
        (eventTarget.addEventListener("visitorConsentCollected", process),
        eventTarget.addEventListener("submit", handleCheckoutSubmit, !0),
        eventTarget.addEventListener("click", handleRebuyCheckoutClick, !0)),
      typeof trackerRoot.addEventListener == "function" &&
        trackerRoot.addEventListener("message", handleFrontrowMessage, !1),
      process(),
      controller
    );
  }
  function shouldSuppressRebuyGiftSync(trackerRoot, event) {
    return !!(
      trackerRoot &&
      trackerRoot.__im8AttributionCartUpdateInFlight === !0 &&
      event &&
      event.type === "rebuy:cart.change"
    );
  }
  return {
    buildConsentAttributes: buildConsentAttributes,
    readLandingTouch: readLandingTouch,
    mergeTouch: mergeTouch,
    buildCartAttributes: buildCartAttributes,
    isMarketingAllowed: isMarketingAllowed,
    createTracker: createTracker,
    install: install,
    shouldSuppressRebuyGiftSync: shouldSuppressRebuyGiftSync,
    isFrontrowOrigin: isFrontrowOrigin,
    buildFrontrowAttributes: buildFrontrowAttributes,
  };
});
//# sourceMappingURL=/cdn/shop/t/121/assets/click-id-attribution.js.map?v=41158130452876739811789124457
